<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_5688_1482)">
      <path
        d="M6.81999 1.15997C6.42666 0.766639 5.79332 0.766639 5.40666 1.15997L1.16666 5.39997C0.773322 5.79331 0.773322 6.42664 1.16666 6.8133L9.17999 14.8266C9.57332 15.22 10.2067 15.22 10.5933 14.8266L14.8333 10.5866C15.2267 10.1933 15.2267 9.55997 14.8333 9.17331L6.81999 1.15997ZM9.41332 13.6466L2.34666 6.57997C2.08666 6.31997 2.08666 5.89997 2.34666 5.63997L5.64666 2.33997C5.90666 2.07997 6.32666 2.07997 6.58666 2.33997L13.66 9.41331C13.92 9.67331 13.92 10.0933 13.66 10.3533L10.36 13.6533C10.1 13.9066 9.67332 13.9066 9.41332 13.6466ZM11.74 0.926639C10.6933 0.373306 9.37332 -0.0266943 7.87332 0.00663902C7.75332 0.00663902 7.69999 0.153306 7.77999 0.239972L10.1 2.55997L10.9867 1.67331C13.0467 2.64664 14.5467 4.58664 14.9133 6.91331C14.9533 7.18664 15.2067 7.37331 15.4867 7.32664C15.76 7.28664 15.9467 7.02664 15.9 6.75331C15.5 4.21997 13.9267 2.08664 11.74 0.926639ZM5.89999 13.4333L5.01332 14.32C2.95332 13.3466 1.45332 11.4066 1.08666 9.07997C1.04666 8.80664 0.793322 8.61997 0.513322 8.66664C0.239989 8.70664 0.0533219 8.96664 0.0999885 9.23997C0.499989 11.78 2.07332 13.9133 4.25999 15.0733C5.30666 15.6266 6.62666 16.0266 8.12666 15.9933C8.24666 15.9933 8.29999 15.8466 8.21999 15.76L5.89999 13.4333Z"
        fill="url(#paint0_linear_5688_1482)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5688_1482"
        x1="0.0928345"
        y1="0.00469971"
        x2="16.1356"
        y2="15.7627"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <clipPath id="clip0_5688_1482">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
